module.exports = __webpack_public_path__ + "static/images/m-lef-matrixmultiselection@2x.a3b8f17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/edit/config/m-lef-matrixmultiselection@2x.png
// module id = 6hs0
// module chunks = 6 7